(function () {
  var TARGET = new Date('2026-09-30T23:59:59+01:00').getTime();
  var selectors = '[data-dd-promo]';

  function pad(n) { return String(n).padStart(2, '0'); }

  function tick() {
    var now = Date.now();
    var diff = TARGET - now;
    var active = diff > 0;
    document.querySelectorAll(selectors).forEach(function (el) {
      el.classList.toggle('is-active', active);
    });

    document.querySelectorAll('[data-dd-mega-timer]').forEach(function (timer) {
      if (!active) {
        timer.textContent = 'Offer ended';
        return;
      }
      var sec = Math.floor(diff / 1000);
      var d = Math.floor(sec / 86400);
      var h = Math.floor((sec % 86400) / 3600);
      var m = Math.floor((sec % 3600) / 60);
      var s = sec % 60;
      timer.textContent = d + 'd ' + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
    });
  }

  function init() {
    tick();
    window.setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
